export default Object.freeze({
  Distributor: 1,
  Partner: 2,
  Reseller: 3,
  ReferralAgent: 4,
});
